import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/Priority/Fetch'
import ActionDelete from '../../store/action/Priority/Delete'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import TextInputField from "../../infra/components/formInput/CustomTextInput";
import {ClientId, DivisionId, PrevilageId} from "../../helper/HelperAuth";
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Priority",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            isadmin:false,
            formSearch: fromJS({
                "search": ""
            }),
            searchForm : fromJS({
                "client-id": '',
                "division-id": '',
                "sender-id" : '',
                "priority-name": ""
            }),
            search: fromJS([
                { widthClass:'col-sm-12', id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "", field: "priority-name", caption: "Name", allowSearch: true },
                { className : "col-sm-2", field: "sender-id", caption: "Sender Id", allowSearch: true },
                { className : "col-sm-2", field: "sla-hours", caption: "SLA-Hours", allowSearch: true },
                { className : "col-sm-2", field: "sla-days", caption: "SLA-Days", allowSearch: true },
                { className : "col-sm-1", cfield: "action", caption: "Actions", allowView: false }    
            ],
            errors: fromJS({})
        };
    
        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
    }

  async componentDidMount(){
        this.props.actionGetAllClient()
        var isAdmin = await this.props.actionFindByGroupId()
        this.setState({isadmin:isAdmin})
    }

    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);
        if(field === 'client-id'){
            formVal = formVal.set('sender-id','')
            formVal = formVal.set('division-id','')
            this.setState({ searchForm:formVal })
            this.setState({client_id: value})

            this.setState({client_id: value})
            this.props.actionGetAllDivision(value);
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id','')
            this.setState({ searchForm:formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ searchForm:formVal })

    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({ 
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew(){
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({ 
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    async handleRemoveClicked(value){
        var body = {
            "data":{
                "priority-id":value.get('priority-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('priority-name') +' Success!', toast.POSITION.TOP_RIGHT);
            this.handleFindSearch(1);
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('priority-name') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');
        let division_id = searchForm.get('division-id');
        let sender_id = searchForm.get('sender-id');
        let category_name = searchForm.get('priority-name');
        let res = null;
        let sender = [""];
        var bodyFInd = {};
        var isAdmin = this.state.isadmin

        if (PrevilageId != 1 && isAdmin == false && client_id == "") client_id = ClientId;
        if (PrevilageId != 1 && isAdmin == false && division_id == "") division_id = DivisionId;

        this.props.actionGetAllSender(client_id, division_id)
        setTimeout(() => {
            res = this.props.senderall;
            if (res.size > 0 ) sender = [];
            {res.map((data, i) =>
                sender.push(data.get('sender-id'))
            )}

            if (sender_id != "" ) sender = [sender_id]
            if (sender.length == 1 && sender[0] == null) {
                setTimeout(() => {
                    res = this.props.senderall;
                    if (res.size > 0) sender.shift();
                    {res.map((dataSender, i) =>
                        sender.push(dataSender.get('sender-id'))
                    )}
                    if(res.size == 0) sender = [""]
                    bodyFInd = {
                        "sender-id" : sender,
                        "priority-name": searchForm.get('priority-name'),
                    }

                    this.props.actionGet(page,this.state.sortForm, bodyFInd);
                }, 1500);
            } else {
                bodyFInd = {
                    "sender-id" : sender,
                    "priority-name": searchForm.get('priority-name'),
                }

                this.props.actionGet(page,this.state.sortForm, bodyFInd);
            }

        }, 3000);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show')){
            return(
                <Form 
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        }else{
            const items = this.props.data ? fromJS(this.props.data) : fromJS({});

            return (
                <CustomGrid
                    title="Priority"
                    columns={ this.state.columns  } 
                    items={ items }  
                    search={ this.state.search }
                    handleSearch={ this.handleSearch }
                    handleViewClicked={this.handleViewClicked}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                >
                </CustomGrid>
            )
        }
    }

    render(){
        const { form, searchForm, errors } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Priority"  : "Edit Priority"  ) : "Priority";
        const  classHide  = title == "Priority" ? 'card show' : 'card hidden';
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>
                <div className=  {classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Division"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('division-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    }) }
                                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                                    placeholder="Sender"
                                    disabled={this.state.disabled}
                                    hasError={errors.has('sender-id')}
                                />
                            </div>
                            <div className='col-sm-6'>
                                <TextInputField className="form-control"
                                    field='priority-name'
                                    value={searchForm.get('priority-name')}
                                    onChange={(field, value) => this.handleChange(field,value, '')}
                                    placeholder="Priority Name"
                                    disabled={ false }
                                    hasError={errors.has('priority-name')}
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success"
                                        onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                        className="btn btn-wide btn-success content-add"
                                        onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
  (state) => {
      return {
        data: state.user.priority,
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
      }
  },
  dispatch => bindActionCreators({
      actionGet: ActionGet,
      actionGetAllClient:ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
      actionDelete: ActionDelete,
      actionFindByGroupId:ActionFindByGroupId
  }, dispatch),
)(Page);